import React from 'react';
import { View, Image, FlatList } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { Icon } from 'react-native-elements';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { PlayerBadgeProps, PlayerFollowerProps } from '../../../store/types/soc_svc';
import { Battle, PremiumAnonymous, PremiumBadge } from '../../../Componentsv1/Icons';
import BadgeCard from './Badge';
import { navigate } from '../../../navigation/RootNavigation';
type FeedHeaderProps = {
    player: PublicPlayerProps,
    actions: string[],
    viewer_id?:string,
    player_follower?: PlayerFollowerProps,
    onActionPress: (action:string) => void
}

const ProfileHeader = ({ actions, viewer_id, player, player_follower, onActionPress }:FeedHeaderProps) => {
    
    const handleActionPress = (action:string) => {
        if(!onActionPress){ return }
        onActionPress(action)
    }

    const renderActions = (data: {item:string, index:number}) => {
        switch(data.item){
            case 'view':
                return (
                    <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', paddingRight:10, paddingLeft:10, margin:4, height:36, borderRadius: 20, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => handleActionPress(data.item)}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>View Profile</Text>
                    </TouchableOpacity>
                )
            case 'edit':
                return (
                    <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', paddingRight:10, paddingLeft:10, margin:4, height:36, borderRadius: 20, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => handleActionPress(data.item)}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>Edit Profile</Text>
                    </TouchableOpacity>
                )
            case 'polls':
                return (
                    <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', paddingRight:10, paddingLeft:10, margin:4, height:36, borderRadius: 20, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => handleActionPress(data.item)}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>Polls</Text>
                    </TouchableOpacity>
                )
            case 'challenge':
                return (
                    <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', paddingRight:10, paddingLeft:10, margin:4, height:36, borderRadius: 20, borderWidth:1, borderColor:Colors.brand.midnight }} onPress={() => handleActionPress(data.item)}>
                        <Battle size={24} color={Colors.brand.midnight}/>
                    </TouchableOpacity>
                )
            case 'chat':
                return (
                    <TouchableOpacity style={{ margin:4, height:36, width:36, borderRadius: 100, borderWidth:1, borderColor:Colors.brand.midnight, padding:5 }} onPress={() => handleActionPress(data.item)}>
                        <Icon size={20} name='message-circle' type='feather' color={Colors.brand.midnight}/>
                    </TouchableOpacity>
                )
            case 'share':
                return (
                    <TouchableOpacity style={{ margin:4, height:36, width:36, borderRadius: 100, borderWidth:1, borderColor:Colors.brand.midnight, padding:5 }} onPress={() => handleActionPress(data.item)}>
                        <Icon size={20} name='share' type='feather' color={Colors.brand.midnight}/>
                    </TouchableOpacity>
                )
            case 'follow':
                const following = player_follower?.status === 'following' ? true : false
                return (
                    <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', paddingRight:10, paddingLeft:10, margin:4, height:36, borderRadius: 20, borderWidth:1, borderColor:Colors.brand.electric, backgroundColor:following ? 'transparent' : Colors.brand.electric }} onPress={() => handleActionPress(data.item)}>
                        <Text size={14} color={following ? Colors.brand.electric : Colors.shades.white} weight='bold' textAlign='center'>{following?'Unfollow':'Follow'}</Text>
                    </TouchableOpacity>
                )
            default: return <></>
        }
    }

    const renderBadges = (data: { item:PlayerBadgeProps, index:number }) => {
        if(!data.item.badge){ return <></> }
        return (
            <View style={{ margin:2 }}>
                <BadgeCard
                    badge={data.item.badge}
                    size={30}
                />
            </View>
        )
    }
    
    if(!player){ return <></> }
    
    return (
        <View style={{  paddingTop:24, marginRight:20, marginLeft:20, paddingBottom:12, borderBottomWidth:1, borderBottomColor:Colors.shades.shade400 }}>
            <View style={{flexDirection:'row'}}>
            <View>
                <Image style={{height:51, width:51, borderRadius:100, marginBottom:10}} source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : require('../../../assets/images/default-avatar.png') }} />
                <View style={{ flexDirection:'row' }}>
                    <View style={{ flexDirection:'row', alignItems:'center' }}>
                        {player.anonymous ?
                        <PremiumAnonymous size={28} color={Colors.incentive.gold}/>
                        :<></>}
                        <View style={{ marginLeft:5 }}>
                            <Text size={16} color={Colors.brand.midnight} weight='bold'>{player.first_name} {player.last_name}</Text>
                            <Text size={16} color={Colors.brand.slate} weight='regular'>@{player.username}</Text>
                        </View>
                    </View>
                    {player.badges ?
                    <View style={{ flex:1, marginLeft:10 }}>
                        <FlatList
                            data={player.badges}
                            renderItem={renderBadges}
                            horizontal
                        />
                    </View>
                    :<></>}
                </View>
                
            </View>
            <View style={{ flex:1, alignItems:'flex-end' }}>
                <FlatList data={actions} renderItem={renderActions} keyExtractor={(item) => item} horizontal showsHorizontalScrollIndicator={false}/>
            </View>
        </View>
        {player.type == 'premium' ?
            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:10, borderRadius:8, backgroundColor:Colors.shades.white, padding:10 }}
            onPress={() => navigate('AuthStack', { screen: 'Premium' })}>
                <PremiumBadge size={40} color={Colors.incentive.gold} />
                <View style={{ marginLeft:10 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold'>PREMIUM PLAYER</Text>
                    {viewer_id == player.player_id ?
                    <Text style={{ marginTop:5 }} size={12} color={Colors.brand.midnight} weight='regular'>Manage My Subscription</Text>
                    :
                    <Text style={{ marginTop:5 }} size={12} color={Colors.brand.midnight} weight='regular'>What is premium? Check it out!</Text>
                    }
                </View>
            </TouchableOpacity>
            :<></>}
        </View>
    )
}

export default ProfileHeader